import { Helper } from '../../../js/util/helper';
// import Siema from 'siema';
import Siema from '../../../js/vendor/siema.js';

export default class Header {
  constructor( node ) {
    this.node = node;
    this.toSlider = this.node.querySelector( '.nav-fourth-lvl__content-container' );
    this.prevSlide = 0;
    this.slider = null;
    this.handleDropdown();
    this.handleButton();
    this.initSlider();
  }
  handleDropdown() {

    let container = this.node.children[ 0 ];

    container.addEventListener( 'click', () => {
      container.classList.toggle( 'nav-fourth-lvl-inner--open' );

      if ( this.node.children[ 0 ].classList.contains( 'nav-fourth-lvl-inner--open' )) {
        container.querySelector( '.svg-icon' ).children[ 0 ].setAttribute( 'xlink:href', '#icon_close' );
      } else {
        container.querySelector( '.svg-icon' ).children[ 0 ].setAttribute( 'xlink:href', '#jumpmark_arrow_transparent' );
      }
    });

  }
  initSlider() {
    let container = this.node.querySelectorAll( '.nav-fourth-lvl__item-container' );
    const l = container.length;

    this.handleWindowResize( l );

    if ( window.innerWidth >= 1024 && window.innerWidth < 1280 && l > 3 ) {
      this.createSliderThree();
    } else if ( window.innerWidth >= 1280 && l > 4 ) {
      this.createSliderFour();
    }
  }
  handleWindowResize( l ) {
    window.addEventListener( 'resize', Helper.debounce(() => {
      if ( window.innerWidth < 1024 && this.slider !== null ) {
        this.destroySlider();
        this.slider = null;
        this.removeSlider();
      } else if ( window.innerWidth >= 1024 && window.innerWidth < 1280 && this.slider !== null ) {

        if ( this.slider.config.perPage === 4 ) {
          this.slider.destroy( true );
          this.resetButtonFocus();
          this.prevSlide = 0;
          this.createSliderThree();
        }

      } else if ( window.innerWidth >= 1024 && window.innerWidth < 1280 && this.slider === null && l > 3 ) {
        this.resetButtonFocus();
        this.prevSlide = 0;
        this.createSliderThree();
      } else if ( window.innerWidth >= 1280 && this.slider !== null ) {

        if ( this.slider.config.perPage === 3 && l > 4 ) {

          this.slider.destroy( true );
          this.resetButtonFocus();
          this.prevSlide = 0;
          this.createSliderFour();

        } else if ( this.slider.config.perPage === 3 && l <= 4 ) {

          this.destroySlider();
          this.slider = null;

          this.removeSlider();
        }
      } else if ( window.innerWidth >= 1280 && this.slider === null && l > 4 ) {
        this.createSliderFour();
      }
    }, 250 ));
  }
  createSliderThree() {
    this.addSlider();
    this.slider = new Siema({
      selector: this.toSlider,
      perPage: 3,
      loop: true,
      onChange: this.handleTabIndex.bind( this )
    });

    this.toSlider.children[ 0 ].classList.add( 'nav-fourth-lvl__slider' );
    this.checkActiveState();
    this.handleTabIndex();
  }
  createSliderFour() {
    this.addSlider();
    this.slider = new Siema({
      selector: this.toSlider,
      perPage: 4,
      loop: true,
      onChange: this.handleTabIndex.bind( this )
    });

    this.toSlider.children[ 0 ].classList.add( 'nav-fourth-lvl__slider' );
    this.checkActiveState();
    this.handleTabIndex();
  }
  destroySlider() {
    this.slider.destroy( true );
  }
  addSlider() {
    if ( !this.node.classList.contains( 'nav-fourth-lvl--slider' )) {
      this.node.classList.add( 'nav-fourth-lvl--slider' );
    }
  }
  removeSlider() {
    if ( this.node.classList.contains( 'nav-fourth-lvl--slider' )) {
      this.node.classList.remove( 'nav-fourth-lvl--slider' );
    }
  }
  handleButton() {
    const prev = this.node.querySelector( '.nav-fourth-lvl__button--left' );
    const next = this.node.querySelector( '.nav-fourth-lvl__button--right' );

    prev.addEventListener( 'click', () => {
      this.slider.prev();
    });

    next.addEventListener( 'click', () => {
      this.slider.next();
    });
  }
  handleTabIndex() {
    let containers = this.node.querySelector( '.nav-fourth-lvl__slider' ).children;
    let l = this.node.querySelectorAll( '.nav-fourth-lvl__item-container' ).length;
    let add = this.slider.config.perPage;
    let restartIndicator = add === 3 ? -2 : -3;
    let count = this.slider.currentSlide;

    l = add === 3 ? l - 7 : l - 9;

    if ( this.prevSlide === count ) {

      for ( let i = 0; i < add; i++ ) {

        this.handleButtonFocusOn( containers[ count + add + i ]);

      }

    } else if (( this.prevSlide > count || count === l ) && count !== restartIndicator ) {

      if ( this.prevSlide === 0 ) {

        for ( let i = 0; i < add; i++ ) {

          this.handleButtonFocusOff( containers[ add + i ]);
          this.handleButtonFocusOn( containers[ count + add + i ]);
        }
      } else {

        this.handleButtonFocusOff( containers[ count + ( add * 2 ) ]);
        this.handleButtonFocusOn( containers[ count + add ]);

      }
    } else if ( this.prevSlide < count || count === restartIndicator ) {

      if ( count === restartIndicator ) {
        for ( let i = 0; i < add; i++ ) {

          this.handleButtonFocusOff( containers[ this.prevSlide + add + i ]);
          this.handleButtonFocusOn( containers[ count + add + i ]);
        }
      } else {
        this.handleButtonFocusOff( containers[ this.prevSlide + add ]);
        this.handleButtonFocusOn( containers[ count + ( add * 2 - 1 ) ]);
      }
    }


    this.prevSlide = count;
  }
  handleButtonFocusOn( container ) {
    let buttons = container.querySelectorAll( '.nav-fourth-lvl__item-link' );

    for ( let button of buttons ) {
      button.tabIndex = 0;
    }
  }
  handleButtonFocusOff( container ) {
    let buttons = container.querySelectorAll( '.nav-fourth-lvl__item-link' );

    for ( let button of buttons ) {
      button.tabIndex = -1;
    }
  }
  resetButtonFocus() {
    let containers = this.node.querySelectorAll( '.nav-fourth-lvl__item-link' );

    for ( let container of containers ) {
      container.tabIndex = -1;
    }
  }
  checkActiveState() {
    let index = -1;
    let items = this.node.querySelectorAll( '.nav-fourth-lvl__item-container' );

    for ( let item = 0; item < items.length; item++ ) {
      if ( items[ item ].classList.contains( 'nav-fourth-lvl__item-container--active' )) {
        index = item + 1;
        break;
      }
    }

    if ( this.slider.perPage >= index ) {
      while ( this.slider.perPage >= index ) {
        this.node.querySelector( '.nav-fourth-lvl__button--left' ).click();
        index = index + 1;
      }
    } else if (( this.slider.perPage * 2 ) <= index ) {
      while (( this.slider.perPage * 2 ) < index ) {
        this.node.querySelector( '.nav-fourth-lvl__button--right' ).click();
        index = index - 1;
      }
    }

  }
}
